import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { constants } from '@pepconnect/constants';
import { EnvironmentService } from '@pepconnect/services/environment.service';
import { UserService } from '@pepconnect/services/user.service';
import { BaseV2SmartComponent } from '@pepconnect/shared/base/base-smart-component-v2';
import { of, switchMap, take } from 'rxjs';

@Component({
  selector: 'app-logout',
  standalone: false,
  templateUrl: './logout.component.html'
})
export class LogoutComponent extends BaseV2SmartComponent implements OnInit {
  private readonly userService = inject(UserService);
  private readonly environmentService = inject(EnvironmentService);
  private readonly router = inject(Router);

  readonly runLogout: boolean = !this.environmentService.isCMS; // do not execute logout on page for CMS users

  ngOnInit() {
    if (this.runLogout) {
      this.authState$.pipe(
        take(1),
        switchMap(authState => {
          if (authState.isLoggedIn) {
            return this.userService.logout(true);
          } else {
            return of(null);
          }
        })
      ).subscribe(user => {
        if (!user) {
          // if the user wasn't logged in, or something weird happened, send them to the home page.
          this.router.navigate([this.authState.user.locale.locale, constants.REDIRECT_REQUIREMENT_ANONYMOUS]);
        }
      })
    }
  }
}
